import {
  ChangeToApprove,
  ETenantSettingActionType
} from './tenant-setting-change';

export class UpdateMetaDataChangeToApprove extends ChangeToApprove {
  constructor(public message: string) {
    super(-1, ETenantSettingActionType.UpdateMetadata, message);
  }
}
